<template>
    <div class="premium">
        <div class="premium-from">
            <div class="title-h3">
                <span>请选择投保方案</span>
            </div>
            <div class="box" name="请选择投保方案">
                <app-modeles
                    :fromData="fromitem"
                    :parentItem="parentItem"
                    @formChange="formChange"
                ></app-modeles>
            </div>
        </div>
    </div>
</template>

<script>
import modeles from "../m/modeles"; //模板
import insureJs from "@/logic/aboutInsure";
import process from "@static/js/process_products2.esm.min";
import _ from "lodash"; //lodash
var vm;
export default {
    props:{
        data:null
    },
    data() {
        return {
            modalType: 1,
            title: "保费测算",
            key: "", //缓存key
            code: "", //产品code
            productProcess: Object, //流程
            fromitem: Array, //测算dom
            parentItem: Array, //测算dom
            fromvalue: Object, //测算结果
            mainData: Object, //全部数据
            calcInfo: new Object(), //保费
            nextStep: "", //下一步流程
            productBaseInfo: {}, //产品信息
            canNext: false, //是否可以点击下一步
            errMsg: "",
            ValueDemonThs: [], //现金价值表头
            ValueDemonData: [], //现金价值数据
            showValueDemon: false, //是否展示现金价值弹窗
            showValueDemonBtn: false, //是否展示现金价值按钮
            ValueDemonParam: null, //获取现金价值数据的参数
            pageLoading: true, //页面加载
            showInsureComfirm: false, //是否显示保险公司投保提示
        };
    },
    components: {
        "app-modeles": modeles, //加载中
    },
    watch:{
        data(data){
            if(!data||!data.length){
                return
            }
            let fromitem = insureJs.initModuleData(
                data
            );
            this.fromitem = fromitem;
            this.parentItem = {
                description: "",
                moduleCode: "productInfo",
                moduleName: "请选择投保方案",
                data:fromitem
            }
        }
    },
    mounted() {
        // if(this.$units.autoJump()){
        //   return;
        // }
        // this.code = this.$route.query.code; //产品code
        // this.getPremium();
    },
    methods: {
        formChange(data) {
            return
            //表单组件返回数据
            var values = insureJs.getFromValues(this.fromitem);
            values.calcInfo = this.calcInfo;
            if (!data.item.noPremium) {
                this.setPremium(values); //获取测算数据
            }
            console.log(JSON.stringify(values));
        },
        getPremium() {
            //获取测算数据
            let step = process.getStep("premium-key");
            this.$http({
                url:'/master/measureCustom/initialData/'+this.code,
                type:'get',
                params: {},
            }).then((data) => {
                let fromitem = insureJs.initModuleData(
                    data.data
                );
                this.fromitem = fromitem;
                this.parentItem = {
                    description: "",
                    moduleCode: "productInfo",
                    moduleName: "请选择投保方案",
                    data:fromitem
                }
                console.log(fromitem);
                this.pageLoading = false;
            })
            .catch((err) => {
                console.log(err);
                // this.$units.backIndex(err);
            });
        },
        setPremium(data) {
            //获取测算数据
            this.canNext = false;
            this.errMsg = "";
            let step = process.getStep("premium-key");
            let param = data ? data : {};
            insureJs
                .getCache("GCI", this.key, param)
                .then((data) => {
                    console.log(data);
                    let fromitem = insureJs.initModuleData(
                        data.data
                    );
                    this.fromitem = fromitem;
                    console.log(fromitem);
                })
                .catch((err) => {
                    console.log(err);
                });
        },
        checkPremium() {
            if (!vm.canNext) return; //正在调用测算，禁止点下一步
            if (vm.errMsg) {
                return vm.$notice.alert(vm.errMsg);
            }
            let checkResult = insureJs.checkFromValues(vm.fromitem);
            if (!checkResult.result) {
                insureJs.showFromErr(checkResult.item);
                return;
            } else {
                this.nextHtml();
            }
        },
        nextHtml(e) {
            if (!this.canNext) return;
            this.canNext = false;
            setTimeout(() => {
                this.canNext = true;
            }, 500);
            if (vm.productBaseInfo.insureComfirm && e != "insureComfirm") {
                return (vm.showInsureComfirm = true);
            }
            //下一页跳转
            var next = vm.nextStep;
            if (next == "HNU") {
                return insureJs.IPURouter(next, vm.key);
            }
            let route = process.getProcess(next);
            vm.$router.push({
                name: route.route,
                params: {
                    key: vm.key,
                },
            });
        },

        celAnt(data) {
            if (data.type == 1) {
                vm.$notice.alert(data.typeMsg);
            }
        },
    },
};
</script>

<style lang="scss">
@import "./premium.scss";
</style>
